<!-- 队式赛设置-->
<template>
<div class="">
    <PageBack :title="title" />
    <div class="" >   
        <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
            <el-tab-pane label="队式赛设置" name="a" >  
                <match-setting :pubId="publishId" :pubType="pubType" ref="matchSetTab"></match-setting>
            </el-tab-pane>
            <el-tab-pane label="选手" name="b" >  
                <player :pubId="publishId" :pubType="pubType" ref="playerTab"></player>
            </el-tab-pane>
            <el-tab-pane label="裁判设置" name="c" >  
                <desk :pubId="publishId" :pubType="pubType" ref="deskTab"></desk>
            </el-tab-pane>
            <el-tab-pane label="编排设置" name="d" >  
                <arrange :pubId="publishId" :pubType="pubType" ref="arrangeTab"></arrange>
            </el-tab-pane> 
            <el-tab-pane label="倒计时" name="j" >
                <count-down :pubId="publishId" :pubType="pubType" ref="timeTab"></count-down>
            </el-tab-pane>   
            <el-tab-pane label="成绩设置" name="g" >
                <set-score :pubId="publishId" :pubType="pubType" ref="setScoreTab"></set-score>
            </el-tab-pane>
            <el-tab-pane label="成绩公示" name="k" >
                <score-refresh :pubId="publishId" :pubType="pubType" ref="scoreRefreshTab"></score-refresh>
            </el-tab-pane>
            <el-tab-pane label="每把成绩" name="h" >
                <team-score-query :pubId="publishId" :pubType="pubType" ref="scoreQueryTab"></team-score-query>
            </el-tab-pane>
            <el-tab-pane label="团体排名" name="e" >
                <group-rank-query :pubId="publishId" :pubType="pubType" ref="groupRankQueryTab"></group-rank-query>
            </el-tab-pane>
            <!-- <el-tab-pane label="总排名" name="i" >
                <total-rank :pubId="publishId" :pubType="pubType" ref="totalRankTab"></total-rank>
            </el-tab-pane>            -->
            <el-tab-pane label="非会员扫码计分" name="f" >  
                <set-number :pubId="publishId" :pubType="pubType" ref="setNumberTab"></set-number>
            </el-tab-pane>

        </el-tabs>            
    </div>
</div>
</template>
<script>
import {mapActions, mapMutations} from "vuex"
import PageBack from '@/components/PageHeader'
import MatchSetting from './components/matchSetting'
import Player from './components/player'
import Arrange from './components/arrange'
import Encounter from './components/encounter'
import SetNumber from './components/setNumber'
import Desk from './components/setDesk'
import SetScore from './components/setScore'
import TeamScoreQuery from './components/teamScoreQuery'
import TotalRank from './components/totalRank'
import countDown from './components/countDown'
import ScoreRefresh from './components/scoreRefresh'
import groupRankQuery from './components/groupRankQuery'
export default {
    components:{
        PageBack,
        MatchSetting,
        Player,
        Arrange,
        Encounter,
        SetNumber,
        Desk,SetScore,
        TeamScoreQuery,
        TotalRank,
        countDown,
        ScoreRefresh,
        groupRankQuery,
    },
    data(){
        return{
            activeName: 'a',
            publishId: '',
            pubType: '',
            ruleForm: {
                matchType: '',
                rankList: []
            },
            eventTypeList: [],
            scoreTypeList: [],            
            singleRankList: [],
            doubleRankList: [],
            checkList: [],
            arrangeRuleList: [],
            comeRuleList: [],    
            pubTitle: '',       
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        }      
    },
    created(){
        this.publishId = this.$route.query.id
        this.pubType = this.$route.query.type
        setTimeout(()=>{
            this.getRound()
        },100)
    },
    mounted(){
        this.activeName = localStorage.getItem('tabs') || 'a'
    },
    methods:{
        ...mapMutations(['SET_ROUND']),
        changeTabs(){
            localStorage.setItem('tabs',this.activeName)
            this.$refs.scoreRefreshTab.stopCountdown()
            this.$refs.playerTab.stopCountdown()
            this.$refs.scoreQueryTab.stopCountdown()
            if(this.activeName === 'b'){
                this.$refs.playerTab.initData()
                this.$refs.playerTab.countDown()
            }else  if(this.activeName === 'c'){
                this.$refs.deskTab.initData()
            }else  if(this.activeName === 'd'){
                this.$refs.arrangeTab.getNewRound()
                this.$refs.arrangeTab.closeShow()
            }else  if(this.activeName === 'g'){
                this.$refs.setScoreTab.initData()
            }else  if(this.activeName === 'f'){
                this.$refs.setNumberTab.initData()
                this.$refs.setNumberTab.handleSignIn()
            }else if(this.activeName === 'h'){                
                this.$refs.scoreQueryTab.initData()
                this.$refs.scoreQueryTab.getTimeQuery()
            }else if(this.activeName === 'i'){
                this.$refs.totalRankTab.initData()
            }else if(this.activeName === 'j'){
                this.$refs.timeTab.getTimeQuery()
            }else if(this.activeName === 'k'){
                this.$refs.scoreRefreshTab.initData()                
                this.$refs.scoreRefreshTab.countDown()
            }else if(this.activeName === 'e'){
                this.$refs.groupRankQueryTab.initData()
            }           
        }, 
        searchQuery() {
            // this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 查询轮数
        getRound(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            title: item['主题'],
                            round:  item['比赛轮数'] + 1,
                            maxRound: item['轮数']
                        }
                    })
                    this.pubTitle = list[0].title
                    this.round = list[0].round <= list[0].maxRound ? list[0].round : list[0].maxRound
                    this.SET_ROUND(this.round)
                }
            })
        },        
    },
    beforeDestroy() {
        this.$refs.scoreRefreshTab.stopCountdown()
        this.$refs.playerTab.stopCountdown()
    },
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.page-form{
    padding: 5px 0;
}
.container {
    background-color: #fff;
}
.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
.detail-wrap {   
    // padding: 30px 60px;
    // font-size: 16px;
    // line-height: 28px;

}
.pub-title{
    text-align: center;
    font-size: 20px;
}
.sub-title{
    padding: 4px 15px;
    font-size: 18px;
    color: #fff;
    background-color: #e62e02;
    border-radius: 5px;
}
.sub-name{
    padding: 10px;
}
.mg-t-20{
    margin-top: 30px;
}
.pub-submit{
    margin-top: 16px;
    width: 20%;
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/team/teamSetting.vue